module.exports = __webpack_public_path__ + "img/63.983a3275.png";